// extracted by mini-css-extract-plugin
module.exports = {"color":"MicroColorCircle_color__2CKui","png":"MicroColorCircle_png__1mVIM","selected":"MicroColorCircle_selected__2g0op","notSelected":"MicroColorCircle_notSelected__2-wRa"};